import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const state = {
  products: [
    {
      categoryId: '1', //商品目录id
      categoryName: '推荐', //商品目录名称
      products: [
        {
          id: '0', //商品id
          name: '手办5g能量限量版玩偶模型', //商品名称
          price: 298, //商品价格
          stock: 10, //商品库存
          description: '淘公仔毛绒玩具', //商品简介
          imgs: [
            require('src/assets/futureshop/p1.png'),
            require('src/assets/futureshop/p1.png'),
            require('src/assets/futureshop/p1.png'),
          ], //商品图片
          thumb: require('src/assets/futureshop/t1.png'),
        },
        {
          id: '1', //商品id
          name: '手办5g支小宝限量版玩偶模型', //商品名称
          price: 298, //商品价格
          stock: 10, //商品库存
          description: '淘公仔毛绒玩具', //商品简介
          imgs: [
            require('src/assets/futureshop/p2.png'),
            require('src/assets/futureshop/p2.png'),
            require('src/assets/futureshop/p2.png'),
          ], //商品图片
          thumb: require('src/assets/futureshop/t2.png'),
        },
        {
          id: '2', //商品id
          name: '手办5g能量限量版玩偶模型', //商品名称
          price: 298, //商品价格
          stock: 10, //商品库存
          description: '淘公仔毛绒玩具', //商品简介
          imgs: [
            require('src/assets/futureshop/p3.png'),
            require('src/assets/futureshop/p3.png'),
            require('src/assets/futureshop/p3.png'),
          ], //商品图片
          thumb: require('src/assets/futureshop/t3.png'),
        },
      ],
    },
    {
      categoryId: '2', //商品目录id
      categoryName: '生活', //商品目录名称
      products: [
        {
          id: '3', //商品id
          name: '手办5g支小宝限量版玩偶模型', //商品名称
          price: 298, //商品价格
          stock: 10, //商品库存
          description: '淘公仔毛绒玩具', //商品简介
          imgs: [
            require('src/assets/futureshop/p2.png'),
            require('src/assets/futureshop/p2.png'),
            require('src/assets/futureshop/p2.png'),
          ], //商品图片
          thumb: require('src/assets/futureshop/t2.png'),
        },
        {
          id: '4', //商品id
          name: '手办5g能量限量版玩偶模型', //商品名称
          price: 298, //商品价格
          stock: 10, //商品库存
          description: '淘公仔毛绒玩具', //商品简介
          imgs: [
            require('src/assets/futureshop/p1.png'),
            require('src/assets/futureshop/p1.png'),
            require('src/assets/futureshop/p1.png'),
          ], //商品图片
          thumb: require('src/assets/futureshop/t1.png'),
        },
        {
          id: '5', //商品id
          name: '手办5g能量限量版玩偶模型', //商品名称
          price: 298, //商品价格
          stock: 10, //商品库存
          description: '淘公仔毛绒玩具', //商品简介
          imgs: [
            require('src/assets/futureshop/p3.png'),
            require('src/assets/futureshop/p3.png'),
            require('src/assets/futureshop/p3.png'),
          ], //商品图片
          thumb: require('src/assets/futureshop/t3.png'),
        },
      ],
    },
    {
      categoryId: '3', //商品目录id
      categoryName: '公仔', //商品目录名称
      products: [
        {
          id: '6', //商品id
          name: '手办5g能量限量版玩偶模型', //商品名称
          price: 298, //商品价格
          stock: 10, //商品库存
          description: '淘公仔毛绒玩具', //商品简介
          imgs: [
            require('src/assets/futureshop/p3.png'),
            require('src/assets/futureshop/p3.png'),
            require('src/assets/futureshop/p3.png'),
          ], //商品图片
          thumb: require('src/assets/futureshop/t3.png'),
        },
        {
          id: '7', //商品id
          name: '手办5g能量限量版玩偶模型', //商品名称
          price: 298, //商品价格
          stock: 10, //商品库存
          description: '淘公仔毛绒玩具', //商品简介
          imgs: [
            require('src/assets/futureshop/p1.png'),
            require('src/assets/futureshop/p1.png'),
            require('src/assets/futureshop/p1.png'),
          ], //商品图片
          thumb: require('src/assets/futureshop/t1.png'),
        },
        {
          id: '8', //商品id
          name: '手办5g支小宝限量版玩偶模型', //商品名称
          price: 298, //商品价格
          stock: 10, //商品库存
          description: '淘公仔毛绒玩具', //商品简介
          imgs: [
            require('src/assets/futureshop/p2.png'),
            require('src/assets/futureshop/p2.png'),
            require('src/assets/futureshop/p2.png'),
          ], //商品图片
          thumb: require('src/assets/futureshop/t2.png'),
        },
      ],
    },
    {
      categoryId: '4', //商品目录id
      categoryName: '办公', //商品目录名称
      products: [
        {
          id: '9', //商品id
          name: '手办5g能量限量版玩偶模型', //商品名称
          price: 298, //商品价格
          stock: 10, //商品库存
          description: '淘公仔毛绒玩具', //商品简介
          imgs: [
            require('src/assets/futureshop/p1.png'),
            require('src/assets/futureshop/p1.png'),
            require('src/assets/futureshop/p1.png'),
          ], //商品图片
          thumb: require('src/assets/futureshop/t1.png'),
        },
        {
          id: '10', //商品id
          name: '手办5g支小宝限量版玩偶模型', //商品名称
          price: 298, //商品价格
          stock: 10, //商品库存
          description: '淘公仔毛绒玩具', //商品简介
          imgs: [
            require('src/assets/futureshop/p2.png'),
            require('src/assets/futureshop/p2.png'),
            require('src/assets/futureshop/p2.png'),
          ], //商品图片
          thumb: require('src/assets/futureshop/t2.png'),
        },
        {
          id: '11', //商品id
          name: '手办5g能量限量版玩偶模型', //商品名称
          price: 298, //商品价格
          stock: 10, //商品库存
          description: '淘公仔毛绒玩具', //商品简介
          imgs: [
            require('src/assets/futureshop/p3.png'),
            require('src/assets/futureshop/p3.png'),
            require('src/assets/futureshop/p3.png'),
          ], //商品图片
          thumb: require('src/assets/futureshop/t3.png'),
        },
      ],
    },
    {
      categoryId: '5', //商品目录id
      categoryName: '电子', //商品目录名称
      products: [
        {
          id: '12', //商品id
          name: '手办5g能量限量版玩偶模型', //商品名称
          price: 298, //商品价格
          stock: 10, //商品库存
          description: '淘公仔毛绒玩具', //商品简介
          imgs: [
            require('src/assets/futureshop/p1.png'),
            require('src/assets/futureshop/p1.png'),
            require('src/assets/futureshop/p1.png'),
          ], //商品图片
          thumb: require('src/assets/futureshop/t1.png'),
        },
        {
          id: '13', //商品id
          name: '手办5g支小宝限量版玩偶模型', //商品名称
          price: 298, //商品价格
          stock: 10, //商品库存
          description: '淘公仔毛绒玩具', //商品简介
          imgs: [
            require('src/assets/futureshop/p2.png'),
            require('src/assets/futureshop/p2.png'),
            require('src/assets/futureshop/p2.png'),
          ], //商品图片
          thumb: require('src/assets/futureshop/t2.png'),
        },
        {
          id: '14', //商品id
          name: '手办5g能量限量版玩偶模型', //商品名称
          price: 298, //商品价格
          stock: 10, //商品库存
          description: '淘公仔毛绒玩具', //商品简介
          imgs: [
            require('src/assets/futureshop/p3.png'),
            require('src/assets/futureshop/p3.png'),
            require('src/assets/futureshop/p3.png'),
          ], //商品图片
          thumb: require('src/assets/futureshop/t3.png'),
        },
      ],
    },
    {
      categoryId: '6', //商品目录id
      categoryName: '时尚', //商品目录名称
      products: [
        {
          id: '15', //商品id
          name: '手办5g能量限量版玩偶模型', //商品名称
          price: 298, //商品价格
          stock: 10, //商品库存
          description: '淘公仔毛绒玩具', //商品简介
          imgs: [
            require('src/assets/futureshop/p1.png'),
            require('src/assets/futureshop/p1.png'),
            require('src/assets/futureshop/p1.png'),
          ], //商品图片
          thumb: require('src/assets/futureshop/t1.png'),
        },
        {
          id: '16', //商品id
          name: '手办5g支小宝限量版玩偶模型', //商品名称
          price: 298, //商品价格
          stock: 10, //商品库存
          description: '淘公仔毛绒玩具', //商品简介
          imgs: [
            require('src/assets/futureshop/p2.png'),
            require('src/assets/futureshop/p2.png'),
            require('src/assets/futureshop/p2.png'),
          ], //商品图片
          thumb: require('src/assets/futureshop/t2.png'),
        },
        {
          id: '17', //商品id
          name: '手办5g能量限量版玩偶模型', //商品名称
          price: 298, //商品价格
          stock: 10, //商品库存
          description: '淘公仔毛绒玩具', //商品简介
          imgs: [
            require('src/assets/futureshop/p3.png'),
            require('src/assets/futureshop/p3.png'),
            require('src/assets/futureshop/p3.png'),
          ], //商品图片
          thumb: require('src/assets/futureshop/t3.png'),
        },
      ],
    },
  ],
  currCategory: 0,
  cart: [],
  totalAmount: 0,
  totalPrice: 0,
}

// EXPORT
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
